export default __webpack_public_path__ + "static/media/mercado-pago.b044e71f.jpg";